import { post } from '@/utils/request'
import dayjs from 'dayjs'

/**
 * @description 运营产品销量数据统计(按日期统计)
 *
 * @param {object} data 请求参数
 * @param {string} data.day 显示日期2020-01-01,选择时间段
 * @param {string} [data.day_end] 显示日期2020-01-01.时间结束的日期
 * @param {string} [data.plug] 需要统计的插件,多个之前,隔开.全部使用all
 */
export default function admin_product_day_rpt(data) {
  data = { ...data || {} }
  if (data.day) {
    data.day = dayjs(data.day).format('YYYY-MM-DD')
  }

  if (data.day_end) {
    data.day_end = dayjs(data.day_end).format('YYYY-MM-DD')
  }

  return post('admin_product_day_rpt', data)
}
